import iconHome from '../../assets/images/icons/icon-home.svg';
import iconCalendar from '../../assets/images/icons/icon-calendar.svg';
import iconAIFolder from '../../assets/images/icons/icon-ai-folder.svg';
import iconStrategy from '../../assets/images/icons/icon-strategy.svg';
import iconStrategyNew from '../../assets/images/icons/icon-strategy-new.svg';
import iconImage from '../../assets/images/icons/icon-new-image.svg';
import iconImageLibrary from '../../assets/images/icons/icon-image.svg';
import iconAiDna from '../../assets/images/icons/icon-ai-dna.svg';
import iconBilling from '../../assets/images/icons/icon-billing.svg';
import iconBatteryLine from '../../assets/images/icons/icon-battery-line.svg';
import iconSettings from '../../assets/images/icons/icon-settings.svg';
import iconTarget from '../../assets/images/icons/icon-target.svg';

const dockIcon = (src, altKey, alt) => ({ src, altKey, alt });

export const desktopNavSections = [
  {
    labelKey: 'desktop.nav.sections.contentAi',
    label: 'Contenuti & AI',
    links: [
      {
        labelKey: 'desktop.nav.links.postReview',
        label: 'Revisione Post',
        ariaLabelKey: 'desktop.nav.links.postReviewAria',
        ariaLabel: 'Apri la schermata di revisione dei post generati dall\'AI',
        href: '/desktop/posts',
        icon: dockIcon(iconHome, 'desktop.nav.icons.home', 'Schermata principale post')
      },
      {
        labelKey: 'desktop.nav.links.aiGenerator',
        label: 'Crea post',
        ariaLabelKey: 'desktop.nav.links.aiGeneratorAria',
        ariaLabel: 'Apri la schermata Crea post',
        href: '/desktop/create-post',
        icon: dockIcon(iconImage, 'desktop.nav.icons.aiGenerator', 'Crea post')
      },
      {
        labelKey: 'desktop.nav.links.imageGallery',
        label: 'Galleria Immagini',
        ariaLabelKey: 'desktop.nav.links.imageGalleryAria',
        ariaLabel: 'Sfoglia immagini caricate e generate',
        href: '/desktop/image-gallery',
        icon: dockIcon(iconImageLibrary, 'desktop.nav.icons.imageGallery', 'Galleria immagini')
      },
      {
        labelKey: 'desktop.nav.links.aiStorage',
        label: 'AI Storage',
        ariaLabelKey: 'desktop.nav.links.aiStorageAria',
        ariaLabel: 'Gestisci i progetti salvati come su MobileAIStorage',
        href: '/desktop/ai-storage',
        icon: dockIcon(iconAIFolder, 'desktop.nav.icons.aiStorage', 'Archivio AI Storage')
      }
    ]
  },
  {
    labelKey: 'desktop.nav.sections.campaigns',
    label: 'Campagne & Insight',
    links: [
      {
        labelKey: 'desktop.nav.links.calendar',
        label: 'Calendario Editoriale',
        ariaLabelKey: 'desktop.nav.links.calendarAria',
        ariaLabel: 'Consulta il calendario dei post mobile',
        href: '/desktop/calendar',
        icon: dockIcon(iconCalendar, 'desktop.nav.icons.calendar', 'Calendario editoriale')
      },
      {
        labelKey: 'desktop.nav.links.strategy',
        label: 'Strategia Campagne',
        ariaLabelKey: 'desktop.nav.links.strategyAria',
        ariaLabel: 'Gestisci le strategie come nella vista MobileStrategy',
        href: '/desktop/strategy',
        icon: dockIcon(iconStrategy, 'desktop.nav.icons.strategy', 'Strategia campagne')
      },
      {
        labelKey: 'desktop.nav.links.strategizer',
        label: 'Strategizer',
        ariaLabelKey: 'desktop.nav.links.strategizerAria',
        ariaLabel: 'Apri Strategizer',
        href: '/strategizer',
        icon: dockIcon(iconTarget, 'desktop.nav.icons.strategizer', 'Strategizer')
      },
      {
        labelKey: 'desktop.nav.links.newStrategy',
        label: 'Nuova Strategia',
        ariaLabelKey: 'desktop.nav.links.newStrategyAria',
        ariaLabel: 'Avvia una nuova strategia con il flusso desktop',
        href: '/desktop/new-strategy',
        icon: dockIcon(iconStrategyNew, 'desktop.nav.icons.newStrategy', 'Nuova strategia')
      }
    ]
  },
  {
    labelKey: 'desktop.nav.sections.account',
    label: 'Account & Sistema',
    links: [
      {
        labelKey: 'desktop.nav.links.profileSettings',
        label: 'Impostazioni account',
        ariaLabelKey: 'desktop.nav.links.profileSettingsAria',
        ariaLabel: 'Gestisci le impostazioni del tuo account desktop',
        href: '/desktop/profile/settings',
        icon: dockIcon(iconSettings, 'desktop.nav.icons.settings', 'Impostazioni account')
      },
      {
        labelKey: 'desktop.nav.links.companyDna',
        label: 'DNA Aziendale',
        ariaLabelKey: 'desktop.nav.links.companyDnaAria',
        ariaLabel: 'Apri la pagina DNA aziendale desktop',
        href: '/strategizer?view=dna',
        icon: dockIcon(iconAiDna, 'desktop.nav.icons.dna', 'DNA aziendale')
      },
      {
        labelKey: 'desktop.nav.links.battery',
        label: 'Pannello Batteria',
        ariaLabelKey: 'desktop.nav.links.batteryAria',
        ariaLabel: 'Controlla lo stato energetico come su MobileBatteryPanel',
        href: '/desktop/battery',
        icon: dockIcon(iconBatteryLine, 'desktop.nav.icons.battery', 'Pannello batteria')
      },
      {
        labelKey: 'desktop.nav.links.subscription',
        label: 'Abbonamento',
        ariaLabelKey: 'desktop.nav.links.subscriptionAria',
        ariaLabel: 'Gestisci i piani e il billing Stripe',
        href: '/desktop/subscription',
        icon: dockIcon(iconBilling, 'desktop.nav.icons.billing', 'Gestione abbonamento')
      }
    ]
  }
];

export default desktopNavSections;
